import { useState, useCallback } from "react";

export default function useSentryError(initial) {
  const [error, setError] = useState(initial);

  const setErrorMessage = useCallback((message,context) => {
    console.error(message,context);
    // TODO: Insert Sentry event log here.
    setError(message)
  },[setError])

  return [error, setErrorMessage];
}
